'use client';

import {
  type AccordionItem,
  DetailAccordion,
} from '../shared/detail-accordion';
import { CONSOLE, MECHANISMS } from './data';
import { BreakerSim } from './visuals/breaker-sim';
import { ChainSim } from './visuals/chain-sim';
import { ClassifierLog } from './visuals/classifier-log';
import { WatchdogWaffle } from './visuals/watchdog-waffle';

/** Each mechanism carries its own playable widget; the copy is a caption. */
const VISUALS: Record<string, React.ReactNode> = {
  'circuit-breaker': <BreakerSim />,
  'fallback-chain': <ChainSim />,
  watchdog: <WatchdogWaffle />,
  classification: <ClassifierLog />,
};

const ITEMS: AccordionItem[] = MECHANISMS.map((mechanism) => ({
  ...mechanism,
  visual: VISUALS[mechanism.id],
}));

export function MechanismsAccordion() {
  return (
    <DetailAccordion
      items={ITEMS}
      eventName="case_study_mechanism_open"
      eventKey="mechanism"
    />
  );
}

export { CONSOLE };
